export type RosterCandidateTableViewId =
    | 'all'
    | 'on-roster'
    | 'client-portal-submitted'
    | 'client-portal-in-process'
    | 'client-portal-out-of-process'

/**
 * Generates a unique row ID for the data grid based on a candidate's ID
 * and, potentially, their roster candidate ID.
 */
export const generateRowId = ({
    id,
    rosterCandidateId,
}: {
    id: string
    rosterCandidateId?: string | null
}) => `${id}${rosterCandidateId ? `/${rosterCandidateId}` : ''}`
